import { RouteConfig } from 'vue-router'

const commonRoutes: RouteConfig[] = [
    {
        path: '/error',
        name: 'error',
        meta: {
            title: 'Error',
            layout: 'enduser',
            requireAuth: false
        },
        props: true,
        component: () => import('@/modules/auth/views/login/error.vue')
    },
    {
        path: '/idp-return',
        alias: ['/dev/idp-return'],
        name: 'registration.idp-return.root',
        meta: {
            title: 'IDP Return',
            layout: 'enduser',
            requireAuth: false
        },
        component: () => import('@/modules/auth/views/login/idp-return.vue')
    },
    {
        path: '/:event_identifier/mcpro-return',
        alias: ['/dev/:event_identifier/mcpro-return', '/:event_identifier/mcpro-return'],
        name: 'registration.mcpro-return.root',
        meta: {
            title: 'Mc Pro Return',
            layout: 'enduser',
            requireAuth: false
        },
        component: () => import('@/modules/auth/views/login/mcpro-return.vue')
    },
    {
        path: '/:event_identifier/mctrade-return',
        alias: ['/dev/:event_identifier/mctrade-return', '/:event_identifier/mctrade-return'],
        name: 'registration.mctrade-return.root',
        meta: {
            title: 'Mc Trade Return',
            layout: 'enduser',
            requireAuth: false
        },
        component: () => import('@/modules/auth/views/login/mctrade-return.vue')
    },
    {
        path: '/idp-choose',
        alias: ['/dev/idp-choose'],
        name: 'registration.idp-choose.root',
        meta: {
            title: 'IDP Choose',
            layout: 'enduser',
            requireAuth: false
        },
        component: () => import('@/modules/auth/views/login/idp-choose.vue')
    },
    {
        path: '/:event_identifier',
        alias: ['/dev/:event_identifier', '/:event_identifier/login'],
        name: 'registration.login.root',
        meta: {
            title: 'Login',
            layout: 'enduser',
            requireAuth: false
        },
        component: () => import('@/modules/auth/views/login/login.vue')
    }
]

export default commonRoutes;
